import axiosInstance from '../axiosInstance';
import { IUser } from '../../types/User';

export const getUserInfo = async () => {
  const response = await axiosInstance.get<IUser>('/users/current');
  return response.data;
};
